import { useTranslation } from 'react-i18next'

import Icon from '../../../../../ui/Icon'
import { DropdownMenu } from '../../../../../dropdownMenu/DropdownMenu'
import { ClubCardDetails } from './clubCardDetails/ClubCardDetails'

import { ClubModelMetadata } from '../../../../../../types/court/court'
import { ActionType } from '../../../../../../constants/actionTypes'
import { formatAddress } from '../../../../../../utils/address/address'

type ClubCardProps = {
  club: ClubModelMetadata
  onAction: (club: ClubModelMetadata, action: ActionType) => void
}

export const ClubCard = ({ club, onAction }: ClubCardProps) => {
  const { t } = useTranslation(['clubs', 'address'])

  const formattedAddress = formatAddress(club.address, {
    number: t('address:number'),
    floor: t('address:floor'),
    apartment: t('address:apartment'),
  })

  return (
    <div className="ph-card club-card">
      {/* Aerial view of a club: a repeating tilted court pattern (see _club-card.scss). */}
      <div className="club-card-preview d-none d-md-flex" aria-hidden="true" />

      <div className="club-card-content">
        <div className="ph-row ph-between club-card-header">
          <div className="club-card-title">
            <h3>
              {club.name}
              <span className="club-card-id mono muted">#{club.id}</span>
            </h3>
            <div className="club-card-address muted tiny" title={formattedAddress || undefined}>
              <Icon name="pin" size={12} />
              <span>{formattedAddress || '-'}</span>
            </div>
          </div>
          <div className="ph-row club-card-corner">
            <span className="badge">
              <Icon name="grid" size={11} />
              {t('clubs.card.courts-count', { count: club.courtsCount ?? 0 })}
            </span>
            <DropdownMenu
              label={t('clubs.card.actions.more')}
              items={[
                {
                  key: 'edit',
                  label: t('clubs.card.actions.edit'),
                  icon: 'edit',
                  onClick: () => onAction(club, ActionType.EDIT),
                },
                {
                  key: 'view-courts',
                  label: t('clubs.card.actions.view-courts'),
                  icon: 'grid',
                  onClick: () => onAction(club, ActionType.VIEW),
                },
                {
                  key: 'delete',
                  label: t('clubs.card.actions.delete'),
                  icon: 'trash',
                  danger: true,
                  onClick: () => onAction(club, ActionType.DELETE),
                },
              ]}
            />
          </div>
        </div>

        <ClubCardDetails club={club} />
      </div>
    </div>
  )
}
